const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";

const routes = [
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor",
    name: "cadastro-de-habilidades-do-servidor",
    meta: {
      allowedPermissions: ["habilidades_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor/novo",
    name: "cadastro-de-habilidades-do-servidor-novo",
    meta: {
      allowedPermissions: ["habilidades_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor/editar/:id",
    name: "cadastro-de-habilidades-do-servidor-editar",
    meta: {
      allowedPermissions: ["habilidades_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor/visualizar/:id",
    name: "cadastro-de-habilidades-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["habilidades_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorShow.vue"
      ),
  },
];

export default routes;
